import React, {useEffect, useState} from 'react';
import {Spinner} from 'react-bootstrap';
import { useStoreState, useStoreActions } from 'easy-peasy';

import AuthorizationChecker from '../../../services/AuthorizationChecker';
import Loader from '../../widgets/Loader';

import HeadsetCard from './HeadsetCard';
import HeadsetAccessibleVideos from './HeadsetAccessibleVideos';
import HeadsetEvents from './HeadsetEvents';
import HeadsetComments from './HeadsetComments';
import HeadsetAccessibleQuizzes from './HeadsetAccessibleQuizzes';
import HeadsetUpdateFormComponent from './HeadsetUpdateFormComponent';
import PropTypes from 'prop-types';

import './HeadsetDetailComponent.scss';
import CustomTabsWithParams from '../../widgets/customTabs/CustomTabsWithParams';

const HeadsetDetailComponent = ({ headset, setMainModalShow }) => {
    const { headsetById, uploadedAndAccessibleVideosByHeadset, eventsByHeadset, commentsByHeadset, isFetchingOneHeadset } = useStoreState(state => state.headsets);
    const { subscriptionsByClientId} = useStoreState(state => state.clients);
    const {fetchHeadsetById} = useStoreActions(actions => actions.headsets);
    const {fetchSubscriptionsByClientId} = useStoreActions(actions => actions.clients);

    const [isFetching, setIsFetching] = useState(false);

    const spinner = (titre) => <div className="disabledTitle">
        <p>{titre}</p>
        <Spinner
            as="span"
            animation="border"
            size="sm"
            aria-hidden="true"
            className='tabspin' />
    </div>;

    useEffect(() => {
      if(headset?.uniqueId){
        setIsFetching(true);
        fetchHeadsetById(headset.uniqueId)
            .then(() => {
                fetchSubscriptionsByClientId(headset.clientUniqueId)
                    .finally(() => setIsFetching(false));
            })
        }
    }, [headset]); 

    if (!headsetById || (headsetById.clientUniqueId !== headset?.clientUniqueId))  return <Loader />;

    const contentTabs = [
        {
            eventKey: "details",
            title: "Infos",
            mountOnEnter: true,
            unmountOnExit: undefined,
            content: <div className="tab_content">
                <HeadsetCard headset={headsetById} setMainModalShow={setMainModalShow} />
            </div>
        },
        {
            eventKey: "headsetEvents",
            title: eventsByHeadset
                ? "Journal de navigation"
                : spinner("Journal de navigation"),
            mountOnEnter: true,
            unmountOnExit: undefined,
            disabled: !eventsByHeadset,
            content: <div className="tab_content">
                <HeadsetEvents events={eventsByHeadset} />      
            </div>
        },
        {
            eventKey: "loadedVideos",
            title: uploadedAndAccessibleVideosByHeadset
                ? "Expériences immersives chargées"
                : spinner("Expériences immersives chargées"),
            mountOnEnter: true,
            unmountOnExit: undefined,
            disabled: !uploadedAndAccessibleVideosByHeadset,
            content: <div className="tab_content">
                <HeadsetAccessibleVideos uploadedAndAccessibleVideos={uploadedAndAccessibleVideosByHeadset} />
            </div>
        },
    ];
    headsetById.isEditable && subscriptionsByClientId && contentTabs.splice(1, 0, {
        eventKey: "updateHeadset",
        title: isFetching ? spinner("Éditer") : "Éditer",
        mountOnEnter: true,
        unmountOnExit: true,
        disabled: isFetching,
        content: <div className="tab_content">
            <HeadsetUpdateFormComponent headset={headsetById} subscriptions={subscriptionsByClientId} />
        </div>
    })
    AuthorizationChecker.isAdmin() && contentTabs.push({
        eventKey: "accessibleQuizzes",
        title: "Quiz accessibles",
        mountOnEnter: true,
        unmountOnExit: undefined,
        content: <div className="tab_content">
            <HeadsetAccessibleQuizzes headsetDeviceId={headsetById.deviceId} headsetDeviceToken={headsetById.deviceToken} />
        </div> 
    });
    AuthorizationChecker.hasGetRightsForProp("headsets", "comments") && contentTabs.push({
        eventKey: "headsetComments",
        title: commentsByHeadset || !isFetchingOneHeadset
            ? "Historique"
            : spinner("Historique"),
        mountOnEnter: true,
        unmountOnExit: undefined,
        disabled: !commentsByHeadset && isFetchingOneHeadset,
        content: <div className="tab_content" style={{ padding: '0' }}>
            <HeadsetComments comments={commentsByHeadset} headset={headset} />
        </div>
    });

    return <CustomTabsWithParams
        contentTabs={contentTabs}
        defaultActiveTabId='details'
        id="headset-activity-tab"
        withParams={false}
    />;
}

HeadsetDetailComponent.propTypes = {
    headset: PropTypes.object.isRequired
}

export default HeadsetDetailComponent;